import styled from '@emotion/styled'
import tw from 'twin.macro'

export const HeroWrapper = styled.section`
  ${tw`
    overflow-hidden
    relative
    w-full
  `}
  &.home {
    ${tw`
      overflow-visible
    `}
  }
`

export const HeroEyebrow = styled.span`
  ${tw`
    block
    text-sm
    font-semibold
    uppercase
    tracking-wide
    sm:text-base
    lg:text-sm
    xl:text-base
  `}
  color: #5785FA;
`

export const HeroTitle = styled.div`
  ${tw`
    mt-4
    text-3xl
    tracking-tight
    font-extrabold
    text-purple-900
    sm:mt-5
    sm:leading-none
    lg:mt-6
    lg:text-4xl
    xl:text-5xl
  `}
`

export const HeroDescription = styled.div`
  ${tw`
    mt-3
    text-base
    text-purple-300
    sm:mt-5
    sm:text-xl
    lg:text-lg
    xl:text-xl
  `}
`

export const HeroLogosCloudWrapper = styled.div`
  ${tw`
    my-12
  `}
`

export const Headline = styled.div`
  ${tw`
    mt-5
    w-full
    text-2xl
    text-center
    text-gray-700
  `}
  color: #425466;
`
